import type { ButtonProps } from 'atoms/Button'
import { FC, ReactNode } from 'react'
import { Button } from 'atoms'
import { useShowContactModal } from 'services/ContactModal'

interface ContactButtonProps {
  theme?: ButtonProps['theme'];
  type?: ButtonProps['type'];
  children?: ReactNode;
}

const ContactButton: FC<ContactButtonProps> = ({
  theme,
  type,
  children,
}) => {
  const showContactModal = useShowContactModal()

  return (
    <Button
      theme={theme}
      type={type}
      onClick={showContactModal}
    >
      {children}
    </Button>
  )
}

export default ContactButton
